export const BACKEND_URL = "https://api.thegreenmiddlemile.com/api/green-middle-mile-backend/"
//export const BACKEND_URL = "http://localhost:8000/api/green-middle-mile-backend/"
